var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showBtn
        ? _c(
            "el-button",
            {
              staticStyle: { "margin-bottom": "20px" },
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.openInit()
                },
              },
            },
            [_vm._v("选择商品")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "选择商品",
            top: "100px",
            width: "1100px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _vm.fromType == 6
                    ? _c(
                        "el-form",
                        {
                          staticClass: "tag-select-form",
                          attrs: {
                            inline: "",
                            size: "small",
                            "label-width": "80px",
                          },
                        },
                        [
                          !_vm.skuOnly
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "SPUID:" } },
                                [
                                  _c("el-input", {
                                    staticClass: "selWidth mr20",
                                    attrs: {
                                      placeholder: "请输入spuid",
                                      size: "small",
                                      clearable: "",
                                      maxlength: "50",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.handleNumberSearchInput(
                                          "spuId"
                                        )
                                      },
                                    },
                                    nativeOn: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.handerSearch($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.listPram.spuId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.listPram, "spuId", $$v)
                                      },
                                      expression: "listPram.spuId",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "SKUID:" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidth mr20",
                                attrs: {
                                  placeholder: "请输入skuid",
                                  size: "small",
                                  clearable: "",
                                  maxlength: "50",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleNumberSearchInput("skuId")
                                  },
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handerSearch($event)
                                  },
                                },
                                model: {
                                  value: _vm.listPram.skuId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listPram, "skuId", $$v)
                                  },
                                  expression: "listPram.skuId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品名称:" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidth mr20",
                                attrs: {
                                  placeholder: "请输入商品名称",
                                  size: "small",
                                  clearable: "",
                                  maxlength: "50",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handerSearch($event)
                                  },
                                },
                                model: {
                                  value: _vm.listPram.productName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listPram, "productName", $$v)
                                  },
                                  expression: "listPram.productName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { staticClass: "search-btns" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handerSearch },
                                },
                                [_vm._v("搜索")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.handleResetSearch },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "el-form",
                        { attrs: { inline: "", size: "small" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品分类" } },
                            [
                              _c("el-cascader", {
                                staticClass: "selWidth mr20",
                                attrs: {
                                  options: _vm.merCateList,
                                  props: _vm.props,
                                  clearable: "",
                                  size: "small",
                                },
                                on: { change: _vm.handerSearch },
                                model: {
                                  value: _vm.listPram.cateId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listPram, "cateId", $$v)
                                  },
                                  expression: "listPram.cateId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "SKU编码" } },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "selWidth mr20",
                                  attrs: {
                                    placeholder: "请输入SKU编码",
                                    size: "small",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.listPram.skuCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "skuCode", $$v)
                                    },
                                    expression: "listPram.skuCode",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                      size: "small",
                                    },
                                    on: { click: _vm.handerSearch },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "SKU名称" } },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "selWidth mr20",
                                  attrs: {
                                    placeholder: "请输入SKU名称",
                                    size: "small",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.listPram.skuName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "skuName", $$v)
                                    },
                                    expression: "listPram.skuName",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                      size: "small",
                                    },
                                    on: { click: _vm.handerSearch },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "multipleTable",
                  staticClass: "table",
                  attrs: {
                    data: _vm.listData.list,
                    size: "mini",
                    "highlight-current-row": "",
                    "row-key": _vm.skuOnly ? "skuId" : undefined,
                    "header-cell-style": { fontWeight: "bold" },
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _vm._v(" "),
                  _vm.selectType == 2 && _vm.fromType == 6 && !_vm.skuOnly
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "spuId",
                          label: "spuid",
                          "min-width": "100",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectType == 2 && _vm.fromType == 6 && _vm.skuOnly
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "skuId",
                          label: "skuid",
                          "min-width": "100",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "image", label: "商品图片" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.image
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "36px",
                                    height: "36px",
                                  },
                                  attrs: {
                                    src: scope.row.image,
                                    "preview-src-list": [scope.row.image],
                                  },
                                })
                              : _vm._e()
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _vm.selectType == 2 && _vm.fromType == 6
                    ? [
                        _c("el-table-column", {
                          attrs: {
                            prop: "skuCode",
                            label: "SKU编码",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        !_vm.skuOnly
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "skuId",
                                label: "skuid",
                                "min-width": "100",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "skuName",
                            label: "SKU名称",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cateName",
                            label: "分类",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "otPrice",
                            label: "价格",
                            "min-width": "150",
                          },
                        }),
                      ]
                    : _vm.selectType == 2
                    ? [
                        _c("el-table-column", {
                          attrs: {
                            prop: "skuCode",
                            label: "SKU编码",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "skuName",
                            label: "SKU名称",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cateName",
                            label: "分类",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "otPrice",
                            label: "价格",
                            "min-width": "150",
                          },
                        }),
                      ]
                    : [
                        _c("el-table-column", {
                          attrs: {
                            prop: "spuCode",
                            label: "商品编码",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "storeName",
                            label: "商品名称",
                            "min-width": "200",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cateValues",
                            label: "商品分类",
                            "min-width": "180",
                          },
                        }),
                        _vm._v(" "),
                        _vm.fromType != 0
                          ? _c("el-table-column", {
                              attrs: { prop: "cost", label: "价格" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.fromType == 0
                          ? _c("el-table-column", {
                              attrs: { prop: "parPrice", label: "面值" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.fromType == 0
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "rechargeType",
                                label: "充值类型",
                                "min-width": "120",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          _vm._s(
                                            { 1: "卡密", 2: "直充" }[
                                              scope.row.rechargeType
                                            ]
                                          )
                                        ),
                                      ])
                                    },
                                  },
                                ],
                                null,
                                false,
                                498126822
                              ),
                            })
                          : _vm._e(),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.listPram.page,
                  "page-sizes": _vm.constants.page.limit,
                  layout: _vm.constants.page.layout,
                  total: _vm.listData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("div", { staticClass: "selected-count" }, [
                _vm._v("已选择 "),
                _c("span", { staticClass: "count" }, [
                  _vm._v(_vm._s(_vm.allSelectedItems.length)),
                ]),
                _vm._v(" 项"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.visible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !_vm.allSelectedItems.length,
                      },
                      on: { click: _vm.handerSubmit },
                    },
                    [_vm._v("确认选择")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }